import React, { useEffect, useRef } from 'react';

const images = [
    { src: '/images/services/fachada.jpg', alt: 'Fachada da loja 3E Máquinas', caption: 'Fachada da loja 3E Máquinas' },
    { src: '/images/services/parceria.jpg', alt: 'Parceria Oficial Husqvarna', caption: 'Parceria Oficial Husqvarna' },
];

const valores = [
    { icon: "fas fa-shield-alt", title: "Segurança", desc: "Priorizamos a segurança em todos os aspectos do trabalho" },
    { icon: "fas fa-star", title: "Qualidade", desc: "Excelência em todos os serviços prestados" },
    { icon: "fas fa-balance-scale", title: "Ética", desc: "Transparência e honestidade em todas as relações" },
    { icon: "fas fa-user-check", title: "Ergonomia", desc: "Foco na utilização correta e ergonômica de equipamentos" },
];

const qualificacoes = [
    "Engenharia da Computação",
    "Engenharia de Segurança do Trabalho",
    "Engenharia de Software",
    "Registro CREA-SP/CONFEA",
    "Instrutores Habilitados em Segurança do Trabalho"
];

const Services = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
        if (sectionRef.current && window.gsap) {
            window.gsap.utils.toArray(sectionRef.current.querySelectorAll('.fade-in')).forEach((el, i) => {
                window.gsap.fromTo(
                    el,
                    { opacity: 0, y: 40 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.8,
                        delay: i * 0.2,
                        ease: "power2.out",
                        scrollTrigger: {
                            trigger: el,
                            start: "top 90%",
                            toggleActions: "play none none none"
                        }
                    }
                );
            });
        }
    }, []);

    return (
        <div ref={sectionRef} className="container mx-auto px-4 py-16">
            {/* Nossa História e Missão */}
            <div className="bg-white rounded-lg shadow-lg p-8 max-w-3xl mx-auto mb-12 fade-in">
                <div className="flex flex-col items-center mb-8">
                    <div className="text-husqvarna-orange text-6xl mb-4">
                        <i className="fas fa-tools"></i>
                    </div>
                    <h1 className="text-4xl font-bold text-husqvarna-dark-gray mb-2 text-center">
                        Serviços Técnicos e Manutenção
                    </h1>
                </div>
                <p className="text-lg text-gray-700 mb-6 text-center">
                    Nossa equipe altamente qualificada oferece assistência técnica, manutenção preventiva e corretiva para toda a linha de equipamentos Husqvarna e outras marcas. Garantimos agilidade, transparência e peças originais para máxima performance e durabilidade das suas máquinas.
                </p>
                <ul className="list-disc pl-6 text-lg text-gray-700 mb-6">
                    <li>Manutenção preventiva e corretiva</li>
                    <li>Revisão completa de equipamentos</li>
                    <li>Troca de peças originais</li>
                    <li>Diagnóstico técnico especializado</li>
                    <li>Atendimento em oficina própria</li>
                </ul>
                <div className="text-center">
                    <a
                        href="mailto:atendimento@3emaquinas.com.br"
                        className="inline-block bg-husqvarna-orange text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-orange-700 transition-colors duration-300 shadow-lg"
                    >
                        Solicitar Atendimento
                    </a>
                </div>
            </div>

            {/* Nossa História */}
            <div className="bg-husqvarna-light-gray rounded-lg shadow-lg p-8 max-w-3xl mx-auto mb-12 fade-in">
                <h2 className="text-3xl font-bold text-husqvarna-dark-gray mb-4 text-center">Nossa História e Missão</h2>
                <p className="text-lg text-gray-700 mb-4 text-center">
                    A 3E Máquinas nasceu da paixão por equipamentos de alta performance. Há mais de <strong>25 anos</strong>, somos referência em manutenção e representação de marcas consagradas como a Husqvarna. Em 2022, iniciamos um novo capítulo com nossa área de treinamentos e perícias, que hoje completa <strong>3 anos</strong> de sucesso.
                </p>
                <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-4">
                    <div className="text-center">
                        <span className="text-4xl font-bold text-husqvarna-orange">25+</span>
                        <div className="text-gray-700">Anos em Manutenção</div>
                    </div>
                    <div className="text-center">
                        <span className="text-4xl font-bold text-husqvarna-orange">3+</span>
                        <div className="text-gray-700">Anos em Treinamentos</div>
                    </div>
                </div>
                <p className="text-lg text-gray-700 mb-4 text-center">
                    Nossa missão é <span className="italic text-husqvarna-orange">"através da segurança e correta utilização das máquinas Husqvarna, melhorar a qualidade do trabalho através da ERGONOMIA"</span>, unindo nossa vasta experiência em manutenção com o conhecimento técnico em segurança.
                </p>
            </div>

            {/* Valores */}
            <div className="bg-white rounded-lg shadow-lg p-8 max-w-3xl mx-auto mb-12 fade-in">
                <h2 className="text-2xl font-bold text-husqvarna-dark-gray mb-6 text-center">Nossos Valores</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    {valores.map((valor, idx) => (
                        <div key={valor.title} className="flex flex-col items-center text-center">
                            <div className="text-husqvarna-orange text-4xl mb-2">
                                <i className={valor.icon}></i>
                            </div>
                            <div className="font-semibold text-lg mb-1">{valor.title}</div>
                            <div className="text-gray-700 text-base">{valor.desc}</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Nossa Equipe */}
            <div className="bg-husqvarna-light-gray rounded-lg shadow-lg p-8 max-w-3xl mx-auto mb-12 fade-in">
                <h2 className="text-2xl font-bold text-husqvarna-dark-gray mb-4 text-center">Nossa Equipe</h2>
                <p className="text-lg text-gray-700 mb-4 text-center">
                    Profissionais altamente qualificados com sólida formação acadêmica e vasta experiência prática em Engenharia de Segurança do Trabalho, Perícias Trabalhistas, Venda e Manutenção de Máquinas e Ferramentas Agro Leve.
                </p>
                <div className="mb-4">
                    <h3 className="font-semibold text-husqvarna-orange mb-2 text-center">Qualificações:</h3>
                    <ul className="list-disc pl-6 text-gray-700 text-base">
                        {qualificacoes.map(q => <li key={q}>{q}</li>)}
                    </ul>
                </div>
            </div>

            {/* Especialização */}
            <div className="bg-white rounded-lg shadow-lg p-8 max-w-3xl mx-auto mb-12 fade-in">
                <h2 className="text-2xl font-bold text-husqvarna-dark-gray mb-4 text-center">Especialização</h2>
                <p className="text-lg text-gray-700 text-center">
                    Especialista em NR-12 (Segurança no Trabalho em Máquinas e Equipamentos) com foco em treinamentos práticos e teóricos para uso seguro de equipamentos Husqvarna.
                </p>
            </div>

            {/* Parceria Oficial */}
            <div className="bg-husqvarna-light-gray rounded-lg shadow-lg p-8 max-w-3xl mx-auto mb-12 fade-in">
                <h2 className="text-2xl font-bold text-husqvarna-dark-gray mb-4 text-center">Parceria Oficial Husqvarna do Brasil</h2>
                <p className="text-lg text-gray-700 text-center mb-4">
                    Somos orgulhosamente parceiros oficiais da Husqvarna do Brasil, oferecendo treinamentos certificados e especializados em equipamentos da marca líder mundial em soluções para floresta, parque e jardim.
                </p>
                <div className="flex flex-col items-center">
                    <img
                        src={images[1].src}
                        alt={images[1].alt}
                        className="rounded-lg shadow-lg w-full max-w-xs object-contain bg-white"
                        loading="lazy"
                    />
                    <span className="text-gray-600 text-sm mt-2">{images[1].caption}</span>
                </div>
            </div>
        </div>
    );
};

export default Services;
                        
